// Copy text to the clipboard. The async Clipboard API is unavailable on
// insecure origins and older browsers, so fall back to a hidden textarea +
// execCommand there. Resolves to true only when the text was actually copied.
export const copyToClipboard = async text => {
  const value = String(text ?? '')

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value)
      return true
    } catch (error) {
      console.error('Failed to copy text: ', error)
    }
  }

  const textArea = document.createElement('textarea')
  textArea.value = value
  textArea.style.position = 'fixed'
  textArea.style.opacity = '0'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  let copied = false
  try {
    copied = document.execCommand('copy')
  } catch (error) {
    console.error('Failed to copy text: ', error)
  }
  document.body.removeChild(textArea)

  return copied
}

export default copyToClipboard
